import Qs from "qs";
const $axios = require("../axios/axios");
import $api from "@/axios/api";
import { AES_Encrypt, AES_Decrypt } from "@/utils/encryp.js";
import $route from "@/router/index";
import $store from "@/store/index";
import i18n from "@/utils/i18n/index";
//指纹id
import Fingerprint2 from "fingerprintjs2";
export { forterCookie } from "./forterCookie.js";
import { clarityAddCustomTags } from "@/utils/clarityUtils.js";

/**
 * 生成sign
 * sign - Encryption and decryption rules
 * Sign encryption/decryption key：@ALCHEMY$VPG!J8vq
 * Sign encryption/Decryption algorithm：通过AES/ECB/PKCS5Padding
 * The content of the generated sign is：userId - Last 5 digits of userno - timestamp，eg：12345678-12345-1645427147261
 * After successful decryption and login，You can get userId from sign,Remove the ACh from the decrypted content of the sign is userId，
 * @returns {Object}
 */
export function generateSign() {
  let obj = {
    sign: "",
    timestamp: new Date().getTime(),
  };
  if (
    window.localStorage.getItem("token") &&
    window.localStorage.getItem("userId") &&
    window.localStorage.getItem("userNo")
  ) {
    let text = window.localStorage.getItem("userId");
    let userId = text.substring(text.lastIndexOf("H") + 1, text.length);
    let userNo = window.localStorage
      .getItem("userNo")
      .substring(localStorage.getItem("userNo").length - 5);
    obj.timestamp = new Date().getTime();
    obj.sign = AES_Encrypt(userId + "-" + userNo + "-" + obj.timestamp);
    window.localStorage.setItem("sign", obj.sign);
    return obj;
  }
  return obj;
}

/**
 * 提交订单、确认订单前获取submit-token公共接口
 * @returns 获取成功返回true，失败则是fasle
 */
export async function querySubmitToken() {
  let params = {
    coin: "ACH",
    email: localStorage.getItem("email"),
  };
  return await $axios.default
    .post($api.post_submitToken, params, "")
    .then((res) => {
      if (res && res.data !== null && res.data) {
        return true;
      }
      return false;
    })
    .catch(() => {
      return false;
    });
}

/**
 * 创建订单
 * @returns 创建成功返回true，失败则是fasle
 */
export async function createOrder() {
  let params = {
    fiat: $store.state.buyNftHome.fiatCurrency.code,
    payWayCode: $store.state.buyNftOrder.payMethodInfo.payWayCode,
    nftParamNo: $store.state.buyNftHome.nftParamNo,
  };
  //Virtual Account入参添加银行code
  params.payBankCode = $store.state.buyNftOrder.payMethodInfo.bankCode;
  return await $axios.default
    .post($api.post_createOrder, params, "")
    .then((res) => {
      if (res && res.data !== null && res.data) {
        $store.commit("buyNftOrder/set_orderNo", res.data.orderNo);
        return true;
      }
      $store.commit("buyNftOrder/set_orderNo", "");
      return false;
    })
    .catch(() => {
      $store.commit("buyNftOrder/set_orderNo", "");
      return false;
    });
}

/**
 * 获取ip
 */
export async function getUserIP() {
  return await $axios.default.get($api.get_userIP, "").then((res) => {
    if (res && res.data) {
      return res.data.ip;
    }
  });
}

/**
 * 获取设备指纹id
 * fingerprint - 设备指纹 ｜ 设备唯一id
 * @url https://dashboard.fingerprint.com
 */
export async function fingerprintId() {
  return await new Promise((resolve) => {
    return Fingerprint2.get(function (components) {
      const values = components.map(function (component, index) {
        if (index === 0) {
          //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
          return component.value.replace(/\bNetType\/\w+\b/, "");
        }
        return component.value;
      });
      // 生成最终id murmur
      let id = Fingerprint2.x64hash128(values.join(""), 31);
      window.localStorage.setItem("fingerprint_id", AES_Encrypt(id));
      resolve(AES_Encrypt(id));
    });
  });
}

/**
 * 生成日本通道token
 * @param cardno - 卡号
 * @param expire - 年月 eg: 2209
 * @returns {Promise<token>}
 */
export function japaneseToken(cardno, expire) {
  let newToken = new Promise((resolve) => {
    window.Multipayment.init("9200004239555"); //トークンを利用するための a    pi キー
    window.Multipayment.getToken(
      {
        cardno: cardno, //加盟店様の購入フォームから取得したカード番号
        expire: expire, //加盟店様の購入フォームから取得したカード有効期限
        tokennumber: "5", //加盟店様の購入フォームから取得したトークン発行数
      },
      function (response) {
        if (response.resultCode !== "000") {
          resolve(false);
        } else {
          resolve(response);
        }
      },
    );
  });
  return newToken;
}

/**
 * hash路由模式获取不到参数问题
 * @returns {Object} - router query、router fullPath
 */
export function hashQuery() {
  let routerObject = {
    query: {},
    fullPath: "",
  };
  if ($route.currentRoute.fullPath !== "/") {
    routerObject.fullPath = $route.currentRoute.fullPath.substring(
      2,
      $route.currentRoute.fullPath.length,
    );
    routerObject.query = $route.currentRoute.query;
  }
  if (location.search !== "") {
    routerObject.fullPath = location.search.substring(
      1,
      location.search.length,
    );
    const index = location.search.indexOf("?");
    if (index === -1) return {};
    const params = location.search.slice(index + 1);
    routerObject.query = Qs.parse(params);
  }

  return routerObject;
}

/**
 * 获取商户信息
 */
export function storeMerchantInfo() {
  //获取地址栏信息
  let routeQuery = JSON.parse(JSON.stringify(hashQuery())).query;

  //兼容商户多语言功能
  if (routeQuery.language) {
    let language = "en-US";
    if (routeQuery.language === "en") {
      language = "en-US";
    } else {
      // if(routeQuery.language && ['en-US','zh-HK','es'].includes(routeQuery.language)){
      language = routeQuery.language;
      // }
    }
    routeQuery.language ? sessionStorage.setItem("language", language) : "";
    i18n.locale = language;
  }
  if (routeQuery.token) {
    let accessToken = decodeURIComponent(routeQuery.token);
    let startIndex = accessToken.indexOf("ACH");
    let endIndex = accessToken.indexOf("ACH", startIndex + 1);
    let userNo = accessToken.substring(0, endIndex);
    let token = accessToken.substring(
      accessToken.indexOf("ACH", endIndex) + 3,
      accessToken.length,
    );
    localStorage.setItem("token", token);
    localStorage.setItem("userNo", userNo);
  }
  routeQuery.id
    ? localStorage.setItem(
        "userId",
        "ACH" + decodeURIComponent(AES_Decrypt(routeQuery.id)),
      )
    : "";
  let email = routeQuery.email ? decodeURIComponent(routeQuery.email) : "";

  if (routeQuery.email && routeQuery.token) {
    localStorage.setItem("email", email);
    localStorage.setItem("login_email", email);
    clarityAddCustomTags();
  }

  //配置商户需要加密邮箱地址
  if (
    $route.currentRoute.query.email &&
    !$route.currentRoute.query.token &&
    JSON.parse(sessionStorage.getItem("buyMerchantInfo")).merchantParam_state
  ) {
    localStorage.setItem("email", email);
    localStorage.setItem("login_email", email);
    clarityAddCustomTags();
  }
}

/**
 * 配置商户只能创建一次订单,创建订单后清空商户数据
 */
export function removeMerchantOrder() {
  let merchantData = JSON.parse(window.sessionStorage.getItem("merchantInfo"));
  if (
    merchantData !== undefined &&
    merchantData &&
    merchantData.merchantOrderNo
  ) {
    window.sessionStorage.removeItem("merchantInfo");
  }
}

/**
 * [checkKycIsRequired 检查是否需要做kyc]
 * @return {Promise<Object>}                 [description]
 * kycIsRequired: Boolean, 是否需要做kyc
 * userLevel: Number, 需要做的kyc等级
 * userLevel: Number, 需要做的kyc等级
 * kycFlag: Number,  kyc标识
 */
export function checkKycIsRequired() {
  let appId;
  try {
    appId = $store.state.merchantInfo.merchantInfo.appId;
  } catch (e) {
    console.log(e);
  }
  return new Promise((resolve) => {
    const params = {
      fiat: $store.state.buyNftHome.fiatCurrency.code,
      amount: $store.state.buyNftOrder.payMethodInfo.amountTotal,
      payWayCode: $store.state.buyNftOrder.payMethodInfo.payWayCode,
      appId,
    };
    $axios.default
      .get($api.get_check, params, "")
      .then((res) => {
        if (res.data) {
          $store.commit("kyc/set_userKycInfoCheck", res.data);
          if (res.data.kycFlag == 0) {
            resolve({
              kycIsRequired: false,
              userLevel: Number(res.data.userLevel),
              kycFlag: Number(res.data.kycFlag),
            });
          } else if (res.data.kycFlag == 1) {
            resolve({
              kycIsRequired: true,
              userLevel: Number(res.data.userLevel),
              kycFlag: Number(res.data.kycFlag),
            });
          } else if (res.data.kycFlag == 2) {
            if (res.data.userLevel == 2) {
              resolve({
                kycIsRequired: true,
                userLevel: Number(res.data.userLevel),
                kycFlag: Number(res.data.kycFlag),
              });
            } else {
              resolve({
                kycIsRequired: false,
                userLevel: Number(res.data.userLevel),
                kycFlag: Number(res.data.kycFlag),
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  });
}
/**
 * [getKycToken 获取kycToken]
 * @return {Promise<string>}          [kycToken]
 */
export function getKycToken() {
  return new Promise((resolve, reject) => {
    const params = {
      // userNo: window.localStorage.getItem('userNo'),
      reference: window.location.origin + "/",
    };
    $axios.default
      .get($api.get_getToken, params, "")
      .then((res) => {
        if (res && res.returnCode === "0000" && res.data) {
          resolve(res.data.token);
        } else {
          reject("get token error");
        }
      })
      .catch((error) => {
        console.error(error);
        reject("get token error");
      });
  });
}
/**
 * [findUserDetail 获取当前用户kyc信息]
 * @return {[Promise<Object>]} [当前用户信息]
 */
export function findUserDetail() {
  return new Promise((resolve, reject) => {
    $axios.default
      .get($api.get_findUserDetail, "", "")
      .then((res) => {
        if (res && res.returnCode === "0000" && res.data) {
          $store.commit("kyc/set_userKycInfoCheck", res.data);
          resolve(res.data);
        } else {
          reject("getKycResult Error");
        }
      })
      .catch((err) => {
        console.log(err);
        reject("getKycResult Error");
      });
  });
}

/**
 * [getQuota 获取kyc限额]
 * @return {[type]} [description]
 */
export function getQuota() {
  return new Promise((resolve) => {
    setTimeout(() => {
      let appId;
      try {
        appId = $store.state.merchantInfo.merchantInfo.appId;
      } catch (e) {
        console.log(e);
      }
      let params = {
        appId,
      };
      $axios.default.get($api.get_getQuota, params, "").then((res) => {
        if (res && res.returnCode === "0000" && res.data) {
          resolve(res.data);
        }
      });
    }, 1000); // 避免kyc成功后获取限额失败;
  });
}

/**
 * [setJumpPathAfterKyc 设置kyc成功之后需要跳转的页面]
 * @param {String} options.path  [description]
 * @param {Object} options.query [description]
 */
export function setJumpPathAfterKyc({ path = "path", query = {} } = {}) {
  $store.commit("kyc/set_jumpPathAfterKyc", { path, query });
}

/**
 * [getKycRule description]
 * @return {[type]} [description]
 */
export function getKycRule() {
  let appId;
  try {
    appId = $store.state.merchantInfo.merchantInfo.appId;
  } catch (e) {
    console.log(e);
  }

  const params = {
    appId,
  };
  $axios.default.get($api.get_kycRule, params, "").then((res) => {
    if (res && res.returnCode === "0000" && res.data) {
      findUserDetail();
    }
  });
}
